import { Alert } from 'antd';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { deleteUserAccount } from '../../api/constlink';
import DeleteUserAccountComponent from '../../components/auth/DeleteUserAccountComponent';
import { RootState } from '../../modules';
import { logoutUserAsync } from '../../modules/auth';

function DeleteUserAccountContainer({ history, match }: RouteComponentProps) {
  const [message, setMessage] = useState<any>();
  const user = useSelector((state: RootState) => state.auth.auth.data);
  const dispatch = useDispatch();

  const onFinish = async (formData: any) => {
    if (user?.name !== formData.userName) {
      setMessage({
        message: '[계정삭제 실패] 사용자 이름이 올바른지 확인해 주세요.',
        isError: true,
      });
      return;
    }
    try {
      await deleteUserAccount();
      setMessage({ message: '사용자 계정이 삭제 되었습니다.', isError: false });

      // logout
      dispatch(logoutUserAsync.request(null, null));
      localStorage.setItem(process.env.REACT_APP_AUTH_TOKEN_NAME!, '');
      history.push('/login');
    } catch (error: any) {
      setMessage({ message: '이미 퇴사/탈퇴한 회원입니다', isError: true });
    }
  };

  const goBack = () => {
    history.goBack();
  };

  return (
    <>
      {message ? (
        <Alert
          message={`${message.message}`}
          type={message.isError ? 'error' : 'success'}
          closable
          // afterClose={handleClose}
        />
      ) : null}
      <DeleteUserAccountComponent onFinish={onFinish} goBack={goBack} />
    </>
  );
}

export default DeleteUserAccountContainer;
